module.exports = __webpack_public_path__ + "36f87ab02b6eaf91fce911aef58e91df.png";